export const postVideo = () => {


    const video = document.querySelector('.post__img video')
    const playBtn = document.querySelector('.post__img-play')

    if (playBtn) {
        playBtn.addEventListener('click', function () {
            video.play()
            video.setAttribute('controls', 'controls')
            playBtn.classList.add('hidden');
        })
    }



}